import {
  AngleMode,
  BazisMaterialHelper,
  CuttingButt,
  CuttingMaterial,
  CuttingPanel,
  FaceBand,
  PanelBase,
  PostformingSideEnum,
} from 'cloud-shared-lib';
import * as _ from 'lodash';

export class ValidWidthButt {
  idButt: number;
  panelThickness: number;
}

export class PanelUtilsHelper {
  static applyFaceBandingInPanels(panels: CuttingPanel[], material: CuttingMaterial, pos: '+' | '-'): void {
    panels.forEach(p => {
      const bands = this.addFaceBand(material, pos, _.cloneDeep(p.panelOutline.faceBanding));
      p.panelOutline.faceBanding = bands;
    });
  }

  static addFaceBand(material: CuttingMaterial, pos: '+' | '-', bands: FaceBand[]): FaceBand[] {
    let nextLevel = 0;

    if (bands.length > 0) {
      if (pos === '+' && Math.max(...bands.map(b => b.level)) > 0) {
        nextLevel = Math.max(...bands.map(b => b.level));
      } else if (pos === '-' && Math.min(...bands.map(b => b.level)) < 0) {
        nextLevel = bands.length > 0 ? Math.min(...bands.map(b => b.level)) : 0;
      }
    }

    if (pos === '+') {
      nextLevel++;
    } else {
      nextLevel--;
    }

    bands.push({
      level: nextLevel,
      material: material,
      order: bands.length + 1,
    } as FaceBand);

    bands.sort((a, b) => b.level - a.level);

    return bands;
  }

  static applyButtsInPanel(panels: CuttingPanel[], butt: CuttingButt, postforming: PostformingSideEnum): void {
    panels.forEach(panel => {
      panel.w1 = butt;
      panel.w2 = butt;

      if (postforming !== PostformingSideEnum.TopAndBottom) panel.l1 = butt;
      if (postforming !== PostformingSideEnum.Bottom) panel.l2 = butt;

      if (panel.panelOutline.topRight.mode !== AngleMode.None) panel.panelOutline.topRight.butt = butt;
      if (panel.panelOutline.topLeft.mode !== AngleMode.None) panel.panelOutline.topLeft.butt = butt;
      if (panel.panelOutline.bottomRight.mode !== AngleMode.None) panel.panelOutline.bottomRight.butt = butt;
      if (panel.panelOutline.bottomLeft.mode !== AngleMode.None) panel.panelOutline.bottomLeft.butt = butt;
    });
  }

  static deleteFaceBandingInPanel(panel: CuttingPanel): void {
    if (panel.panelOutline.faceBanding.length > 0) {
      panel.panelOutline.faceBanding.splice(0, panel.panelOutline.faceBanding.length);
    }
  }

  static replaceFaceBanding(panels: CuttingPanel[], material: CuttingMaterial, oldMaterial: CuttingMaterial): void {
    panels.forEach(panel => {
      if (panel.panelOutline.faceBanding.length > 0) {
        panel.panelOutline.faceBanding.forEach(item => {
          if (BazisMaterialHelper.compareMaterials(item.material, oldMaterial)) {
            item.material = material;
          }
        });
      }
    });
  }

  static getFullPanelThickness(materialThickness: number, panel: PanelBase): number {
    const isCuttingPanel = (panel: PanelBase): panel is CuttingPanel =>
      !_.isNil((panel as CuttingPanel).panelOutline.faceBanding);

    let totalThickness = 0;

    if (isCuttingPanel(panel) && panel.panelOutline.faceBanding.length > 0) {
      totalThickness =
        materialThickness + panel.panelOutline.faceBanding.map(b => b.material.thickness).reduce((a, v) => a + v);

      return totalThickness;
    }

    return materialThickness;
  }

  static getUniqueValidWidthButts(materialThickness: number, panels: PanelBase[]): ValidWidthButt[] {
    const uniqueValidWidthButts: ValidWidthButt[] = _(panels)
      .flatMap((p: PanelBase) => {
        const panelThickness = this.getFullPanelThickness(materialThickness, p);
        return _.compact([
          p.w1?.id,
          p.w2?.id,
          p.l1?.id,
          p.l2?.id,
          p.panelOutline.topLeft.butt?.id,
          p.panelOutline.topRight.butt?.id,
          p.panelOutline.bottomLeft.butt?.id,
          p.panelOutline.bottomRight.butt?.id,
        ]).map(idButt => ({ idButt, panelThickness }));
      })
      .uniqWith(_.isEqual)
      .value();

    return uniqueValidWidthButts;
  }
}
